
import { Component, Vue, Prop } from 'vue-property-decorator';

// Interface for option structure
interface OpcionI {
  nombre: string;
  valor: number;
  descripcion: string;
  descripcion_bajada: string;
}

@Component
export default class Eleccion extends Vue {
  @Prop({ default: '' }) readonly titulo!: string;
  @Prop({ default: null }) readonly valor!: number | null;
  @Prop({ default: () => [] }) readonly opciones!: OpcionI[];

  // Computed property for selected option
  get opcionElegida(): OpcionI | undefined {
    return this.opciones.find((opcion: OpcionI) => opcion.valor === this.valor);
  }

  // Method to handle option selection
  selectOption(valor: number): void {
    this.$emit('update:valor', valor);
  }

  // Method to handle radio button change
  handleChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.$emit('update:valor', Number(target.value));
  }
}
